import React from 'react';
import classNames from 'classnames';
import styles from './Input.module.css';

type InputProps = {
  id: string
  placeholder: string
  type: string
  label?: string
  isLongLabel?: boolean
  required?: boolean
  error?: boolean
  min?: number
  max?: number
  maxLength?: number
  value?: string | number
  width?: number
  textboxWidth?: number
  onUpdate: (value: any) => void
}

function Input(props: InputProps) {

  const changeHandler = (event: any) => {
    event.preventDefault();
    props.onUpdate(event.target.value);
  };

  return (
    <div
      className={styles.container}
      style={{ width: props.width }}
    >
      {props.label &&
        <label htmlFor={props.id} className={classNames(
          styles.label, props.isLongLabel && styles.longLabel, { [styles.required]: props.error },
        )}>
          <span>{props.label}</span>
          {props.required && <span className={styles.required}>*</span>}
        </label>
      }
      <input
        id={props.id}
        className={classNames(styles.input, { [styles.error]: props.error })}
        style={{ width: props.textboxWidth }}
        placeholder={props.placeholder}
        type={props.type}
        onChange={changeHandler}
        min={props.min}
        max={props.max}
        maxLength={props.maxLength}
        value={props.value}
      />
    </div>
  );
}

export default Input;
